import apiService from "@/webapi/api/api_service"

export default {
  apiService,
};
